import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=ae8ea008&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports